import { useState } from "react";
import { AnimatePresence } from "framer-motion";
import "@/App.css";

import SmoothScroll from "./components/SmoothScroll";
import CustomCursor from "./components/CustomCursor";
import Preloader from "./components/Preloader";
import Navigation from "./components/Navigation";
import CaseStudyOverlay from "./components/CaseStudyOverlay";

import Hero from "./sections/Hero";
import Marquee from "./sections/Marquee";
import Showreel from "./sections/Showreel";
import SelectedWork from "./sections/SelectedWork";
import ContentBreakdown from "./sections/ContentBreakdown";
import SystemAnimation from "./sections/SystemAnimation";
import Services from "./sections/Services";
import Metrics from "./sections/Metrics";
import Testimonials from "./sections/Testimonials";
import CaseStudies from "./sections/CaseStudies";
import About from "./sections/About";
import FinalCTA from "./sections/FinalCTA";
import Footer from "./sections/Footer";

import { CASE_STUDIES } from "./data/site";

function App() {
  const skip =
    typeof window !== "undefined" &&
    window.location.search.includes("nopreload");
  const [loading, setLoading] = useState(!skip);
  const [activeCase, setActiveCase] = useState(null);
  const study = CASE_STUDIES.find((c) => c.id === activeCase) || null;

  return (
    <div className="App">
      <div className="grain" aria-hidden />
      <CustomCursor />

      <AnimatePresence>
        {loading && <Preloader onDone={() => setLoading(false)} />}
      </AnimatePresence>

      <SmoothScroll>
        <Navigation />
        <main>
          <Hero />
          <Marquee />
          <Showreel />
          <SelectedWork onOpen={setActiveCase} />
          <ContentBreakdown />
          <SystemAnimation />
          <Services />
          <Metrics />
          <Testimonials />
          <CaseStudies onOpen={setActiveCase} />
          <About />
          <FinalCTA />
          <Footer />
        </main>
      </SmoothScroll>

      <AnimatePresence>
        {study && (
          <CaseStudyOverlay study={study} onClose={() => setActiveCase(null)} />
        )}
      </AnimatePresence>
    </div>
  );
}

export default App;
